import {
    EMPLOYEE_STORE,
    VENDOR_STORE,
    TRUCK_STORE,
    INSTRUCTION_STORE,
    TOOLBOXTALK_STORE,
    TRAINING_DUE_STORE,
    COST_CODE_STORE,
    GL_CODE_STORE,
    USER_STORE,
    CODE_GROUP_STORE,
    JOB_STORE,
    TRAINING_DUE_TEXT_STORE,
    INI_STORE,
    ENERGY_STORE,
    CONDITIONS_STORE,
    DOCS_PERMIT_STORE,
    EVALUATION_OF_WORK_STORE, JOB_TASK_STORE, WORK_ACTIVITIES_STORE, TEMPS_STORE, TEMP_AGENCY_STORE, TRAINER_STORE,
    JHA_DOCUMENT_TRIGGER_STORE,
    DAILY_LOG_STORE,
    ALT_JOB_STORE,
    EQUIPMENT_STORE,
    EQUIP_LOCATION_STORE,
    PURCHASE_ORDER_STORE,
    PRACTICAL_EVALUATION_TYPE_STORE,
    TOOL_INVENTORY_STORE,
    TOOL_STORE,
    TOOL_CALIBRATION_STORE,
    TOOL_DOCS_STORE,
    TOOL_ASSIGNMENT_STORE,
    SDS_STORE,
    TRAINING_COURSE_STORE,
    TRAINING_QUIZ_STORE,
    TRAINING_SESSION_STORE,
    INCIDENT_STORE,
    JSSI_SCHEMA_STORE,
    SAFETY_SCHEDULE_STORE
} from './constants';
import axiosInstance from '../axiosInstance';
import { applySyncPayload } from '../services/safetyScheduleService';
import jobSiteSafetyInspectionSchemaService from '../services/jobSiteSafetyInspectionSchemaService';
import { createWeeklyInstructions } from '../functions/createWeeklyInstructions';

// В каждом пункте — Store, endpoint, localStorageKey. Если нужна индивидуальная логика — добавляем syncHandler.
export const syncConfig = {
    user: {
        storeName: USER_STORE,
        endpoint: '/user',
        localStorageKey: 'lastUserSyncTime',


        async syncHandler(db, storeName, data) {

            const tx = db.transaction(storeName, 'readwrite');
            const store = tx.objectStore(storeName);

            await store.clear();

            await store.put({
                id: data.userId ?? 1,
                firstName: data.firstName ?? '',
                lastName: data.lastName ?? '',
                employeeId: data.employeeId ?? '',
                roles: data.roles ?? [],
                updatedAt: new Date().toISOString(),
            });

            await tx.done;

            // временно в Localstorage что бы оставить прошлый функционал до рефактора
            localStorage.setItem('firstName', data.firstName ?? '');
            localStorage.setItem('lastName', data.lastName ?? '');
            localStorage.setItem('userId', data.userId ? String(data.userId) : '');
            localStorage.setItem('employeeId', data.employeeId ? String(data.employeeId) : '');
            localStorage.setItem('employeeFullName', data.employeeFullName ?? '');
            localStorage.setItem('employeeDivision', data.employeeDivision ?? '');
            localStorage.setItem('employeeCompanyCode', data.employeeCompanyCode ?? '');
            localStorage.setItem('employeePhone', data.employeePhone ?? '');
            localStorage.setItem('employeeMVR', data.employeeMVR ?? '');
            localStorage.setItem('roles', JSON.stringify(data.roles ?? []));


        },
    },

    employees: {
        storeName: EMPLOYEE_STORE,
        endpoint: '/employees',
        localStorageKey: 'lastEmployeeSyncTime',
    },
    toolboxtalks: {
        storeName: TOOLBOXTALK_STORE,
        endpoint: '/instructions',
        localStorageKey: 'lastToolBoxTalkSyncTime',
        supportsIncrementalSync: true, // Поддержка инкрементальной синхронизации
        async syncHandler(db, storeName, data, isFirstSync) {
            const tx = db.transaction(storeName, 'readwrite');
            const store = tx.objectStore(storeName);

            // Если первая синхронизация - очищаем всё (удаляем старые данные)
            if (isFirstSync) {
                await store.clear();
                console.log('[ToolBoxTalks] First sync - cleared store');
            }

            let addedCount = 0;
            let updatedCount = 0;
            let deletedCount = 0;

            // Сохраняем/обновляем/удаляем пришедшие записи
            for (const talk of data) {
                // Проверяем статус записи
                if (talk.status === false) {
                    // Запись деактивирована - удаляем из IndexedDB
                    const existing = await store.get(talk.id);
                    if (existing) {
                        await store.delete(talk.id);
                        deletedCount++;
                        console.log(`[ToolBoxTalks] Deleted deactivated record ID=${talk.id}`);
                    }
                } else {
                    // Запись активна - сохраняем/обновляем
                    const existing = await store.get(talk.id);
                    if (existing) {
                        updatedCount++;
                    } else {
                        addedCount++;
                    }
                    await store.put(talk);
                }
            }

            await tx.done;
            console.log(`[ToolBoxTalks] Sync completed (${isFirstSync ? 'full' : 'incremental'}): added=${addedCount}, updated=${updatedCount}, deleted=${deletedCount}`);
        },
    },
    trainingDueText: {
        storeName: TRAINING_DUE_TEXT_STORE,
        endpoint: '/field-training-master',
        localStorageKey: 'lastTrainingDueText',
    },
    trainingDue: {
        storeName: TRAINING_DUE_STORE,
        endpoint: '/training-due',
        localStorageKey: 'lastTrainingDueSyncTime',
    },
    costCode: {
        storeName: COST_CODE_STORE,
        endpoint: '/cost-code',
        localStorageKey: 'lastCostCodeSyncTime',
    },
    glCode: {
        storeName: GL_CODE_STORE,
        endpoint: '/gl-code',
        localStorageKey: 'lastGLCodeSyncTime',
    },
    codeGroup: {
        storeName: CODE_GROUP_STORE,
        endpoint: '/code-group',
        localStorageKey: 'lastCodeGroupSyncTime',
        async syncHandler(db, storeName, data) {

            // Подготовим массивы для объединения
            const mergedCostCodes = [];
            const mergedGlCodes = [];

            // Пробежимся по каждому элементу массива data
            for (const item of data) {
                if (Array.isArray(item.costCodes)) {
                    mergedCostCodes.push(...item.costCodes);
                }
                if (Array.isArray(item.glCodes)) {
                    mergedGlCodes.push(...item.glCodes);
                }
            }

            const tx = db.transaction(storeName, 'readwrite');
            const cgStore = tx.objectStore(storeName);

            // Очищаем store, чтобы не копить кучу старых записей
            await cgStore.clear();

            // Вставляем одну новую запись c id=1
            const record = {
                id: 1,
                costCodes: mergedCostCodes,
                glCodes: mergedGlCodes,
                updatedAt: new Date().toISOString(),
            };

            await cgStore.put(record);
            await tx.done;
        },
    },
    job: {
        storeName: JOB_STORE,
        endpoint: '/job',
        localStorageKey: 'lastJobSyncTime',
    },
    altJob: {
        storeName: ALT_JOB_STORE,
        endpoint: '/alternative-job',
        localStorageKey: 'lastAltJobSyncTime',
    },
    ini: {
        storeName: INI_STORE,
        endpoint: '/ini',
        localStorageKey: 'lastIniSyncTime',
    },
    energy: {
        storeName: ENERGY_STORE,
        endpoint: '/energy',
        localStorageKey: 'lastEnergySyncTime',
    },
    conditions: {
        storeName: CONDITIONS_STORE,
        endpoint: '/conditions',
        localStorageKey: 'lastConditionsSyncTime',
    },
    docsPermits: {
        storeName: DOCS_PERMIT_STORE,
        endpoint: '/docs-permits',
        localStorageKey: 'lastDocsPermitsSyncTime',
    },
    evaluationOfWork: {
        storeName: EVALUATION_OF_WORK_STORE,
        endpoint: '/evaluation-of-work',
        localStorageKey: 'lastEvaluationOfWorkSyncTime',
    },
    jobTask: {
        storeName: JOB_TASK_STORE,
        endpoint: '/job-task',
        localStorageKey: 'lastJobTaskSyncTime',
    },
    workActivities: {
        storeName: WORK_ACTIVITIES_STORE,
        endpoint: '/work-activities',
        localStorageKey: 'lastWorkActivitiesSyncTime',
    },
    jhaDocumentTriggers: {
        storeName: JHA_DOCUMENT_TRIGGER_STORE,
        endpoint: '/jha-document-triggers',
        localStorageKey: 'lastJhaDocumentTriggersSyncTime',
        supportsIncrementalSync: true,
        skipDefaultFetch: true,
        // Endpoint response shape:
        //   { data: [{id, documentKey, documentName, docsPermitsId, specialDocumentType,
        //             status, lastUpdatedAt, conditions: [...]}],
        //     serverTime, count, activeIds: [int] }
        //
        // activeIds — список id всех ЖИВЫХ триггеров. Используем для
        // reconciliation: удаляем из IDB всё чего нет в этом списке. Это чистит:
        //   - soft-deleted (status=false) триггеры
        //   - hard-deleted строки (от старого кода или ручного удаления из БД)
        //     которые не приходят в incremental data, но и не в activeIds
        async syncHandler(db, storeName, _data, isFirstSync) {
            const lastSyncTime = localStorage.getItem('lastJhaDocumentTriggersSyncTime');
            let endpoint = '/jha-document-triggers';
            if (lastSyncTime && !isFirstSync) {
                endpoint += `?lastSyncTimestamp=${encodeURIComponent(lastSyncTime)}`;
            }

            const resp = await axiosInstance.get(endpoint);
            const body = resp.data || {};
            const items = Array.isArray(body.data) ? body.data : [];
            const activeIds = Array.isArray(body.activeIds) ? new Set(body.activeIds) : null;
            const serverTime = body.serverTime;

            if (!db.objectStoreNames.contains(storeName)) {
                console.error(`[Sync] Store ${storeName} does not exist`);
                return;
            }

            const tx = db.transaction(storeName, 'readwrite');
            const store = tx.objectStore(storeName);

            if (isFirstSync) {
                await store.clear();
            }

            // 1) Apply incremental changes
            for (const t of items) {
                if (!t || typeof t.id !== 'number') continue;
                if (t.status === false) {
                    try { await store.delete(t.id); } catch (_) {}
                    continue;
                }
                await store.put(t);
            }

            // 2) Reconciliation — удаляем из IDB всё чего нет в activeIds
            // (защита от hard-deletes + любого desync'а)
            if (activeIds) {
                const allKeys = await store.getAllKeys();
                for (const key of allKeys) {
                    if (!activeIds.has(Number(key))) {
                        try { await store.delete(key); } catch (_) {}
                    }
                }
            }

            await tx.done;

            // Записываем serverTime — обычно это делает syncDataGeneric, но мы
            // через skipDefaultFetch обходим его.
            if (serverTime) {
                localStorage.setItem('lastJhaDocumentTriggersSyncTime', serverTime);
            } else {
                localStorage.setItem('lastJhaDocumentTriggersSyncTime', new Date().toISOString());
            }
        },
    },
    temps: {
        storeName: TEMPS_STORE,
        endpoint: '/temps',
        localStorageKey: 'lastTempsSyncTime',
    },
    tempAgency: {
        storeName: TEMP_AGENCY_STORE,
        endpoint: '/temp-agency',
        localStorageKey: 'lastTempAgencySyncTime',
    },
    vendors: {
        storeName: VENDOR_STORE,
        endpoint: '/vendors',
        localStorageKey: 'lastVendorsSyncTime',
    },
    trucks: {
        storeName: TRUCK_STORE,
        endpoint: '/trucks',
        localStorageKey: 'lastTrucksSyncTime',
    },
    trainers: {
        storeName: TRAINER_STORE,
        endpoint: '/daily-log/trainers',
        localStorageKey: 'lastTrainersSyncTime',
    },
    dailyLogs: {
        storeName: DAILY_LOG_STORE,
        endpoint: '/daily-log',
        localStorageKey: 'lastDailyLogSyncTime',
        async syncHandler(db, storeName, data) {
            // Helper function to get today's date in consistent format
            const getTodayDate = () => {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            const today = getTodayDate();
            const tx = db.transaction(storeName, 'readwrite');
            const store = tx.objectStore(storeName);

            // Get all existing logs to preserve pending ones
            const allLogs = await store.getAll();
            const pendingLogs = allLogs.filter(log =>
                log.syncStatus === 'pending' && !log.deleted
            );

            // Clear only today's synced logs
            for (const log of allLogs) {
                if (log.date && log.date.split('T')[0] === today &&
                    log.syncStatus === 'synced') {
                    await store.delete(log.localId);
                }
            }

            // Add new logs from server
            for (const log of data) {
                const logDate = log.date ? log.date.split('T')[0] : today;
                if (logDate === today) {
                    await store.put({
                        ...log,
                        localId: `server_${log.id}`,
                        syncStatus: 'synced',
                        date: log.date || today
                    });
                }
            }

            // Re-add pending logs
            for (const pendingLog of pendingLogs) {
                await store.put(pendingLog);
            }

            await tx.done;
        },
    },
    featureVisibility: {
        storeName: null, // No IndexedDB store needed, only localStorage
        endpoint: '/feature-visibility',
        localStorageKey: 'lastFeatureVisibilitySyncTime',
        supportsIncrementalSync: true,
        async syncHandler(db, storeName, data, isFirstSync) {
            // data comes as { data: [...], serverTime: '...', noChanges?: true }
            // but syncService already extracts .data for us, so data = array or []

            // If noChanges flag was set, data will be empty — keep existing localStorage
            if (!isFirstSync && Array.isArray(data) && data.length === 0) {
                console.log('[FeatureVisibility] No changes since last sync, keeping cached data');
                return;
            }

            const features = Array.isArray(data) ? data : [];
            if (features.length > 0 || isFirstSync) {
                localStorage.setItem('featureVisibility', JSON.stringify(features));
                console.log(`[FeatureVisibility] Synced ${features.length} features`);
            }
        },
    },
    jobSiteSafetyInspectionSchema: {
        storeName: JSSI_SCHEMA_STORE,
        endpoint: '/job-site-safety-inspection-schema',
        localStorageKey: 'lastJssiSchemaSyncTime',
        // The handler does its own fetch so it can send ?knownVersion= and skip the download entirely
        // when the device is already on the published revision.
        skipDefaultFetch: true,
        async syncHandler(db, storeName) {
            await jobSiteSafetyInspectionSchemaService.sync(db, storeName);
            // skipDefaultFetch returns before syncService writes the timestamp, so write it here —
            // otherwise every pass looks like a first sync and the Sync page shows "Never".
            localStorage.setItem('lastJssiSchemaSyncTime', new Date().toISOString());
        },
    },
    safetySchedule: {
        storeName: SAFETY_SCHEDULE_STORE,
        endpoint: '/safety-schedule',
        localStorageKey: 'lastSafetyScheduleSyncTime',
        // Ответ — объект с метаданными, а не плоский массив: в стор ложатся
        // назначения, заметки дня и расписание команды для Group View.
        // Через applySyncPayload, а не напрямую: пока в очереди лежат отметки,
        // сделанные без связи, стор не затираем — иначе они пропали бы с экрана.
        async syncHandler(db, storeName, data) {
            await applySyncPayload(db, storeName, data);
        },
    },
    equipment: {
        storeName: EQUIPMENT_STORE,
        endpoint: '/equipment',
        localStorageKey: 'lastEquipmentSyncTime',
        supportsIncrementalSync: true,
        skipDefaultFetch: true,
        async syncHandler(db, storeName, data, isFirstSync) {
            await paginatedSyncHandler(db, storeName, '/equipment', 'Equipment', isFirstSync);
        },
    },
    equipLocations: {
        storeName: EQUIP_LOCATION_STORE,
        endpoint: '/equipment/locations',
        localStorageKey: 'lastEquipLocationSyncTime',
        supportsIncrementalSync: true,
        skipDefaultFetch: true,
        async syncHandler(db, storeName, data, isFirstSync) {
            await paginatedSyncHandler(db, storeName, '/equipment/locations', 'EquipLocations', isFirstSync);
        },
    },
    purchaseOrders: {
        storeName: PURCHASE_ORDER_STORE,
        endpoint: '/equipment/purchase-orders',
        localStorageKey: 'lastPurchaseOrderSyncTime',
        supportsIncrementalSync: true,
        skipDefaultFetch: true,
        async syncHandler(db, storeName, data, isFirstSync) {
            await paginatedSyncHandler(db, storeName, '/equipment/purchase-orders', 'PurchaseOrders', isFirstSync);
        },
    },
    practicalEvaluationTypes: {
        storeName: PRACTICAL_EVALUATION_TYPE_STORE,
        endpoint: '/practical-evaluation/types',
        localStorageKey: 'lastPracticalEvaluationTypeSyncTime',
    },
    toolInventory: {
        storeName: TOOL_INVENTORY_STORE,
        endpoint: '/tool-inventory',
        localStorageKey: 'lastToolInventorySyncTime',
        supportsIncrementalSync: true,
        async syncHandler(db, storeName, data, isFirstSync) {
            await incrementalSyncWithDeletion(db, storeName, data, isFirstSync, 'ToolInventory');
        },
    },
    tools: {
        storeName: TOOL_STORE,
        endpoint: '/tool',
        localStorageKey: 'lastToolsSyncTime',
        supportsIncrementalSync: true,
        async syncHandler(db, storeName, data, isFirstSync) {
            await incrementalSyncWithDeletion(db, storeName, data, isFirstSync, 'Tool');
        },
    },
    toolCalibration: {
        storeName: TOOL_CALIBRATION_STORE,
        endpoint: '/tool-calibration',
        localStorageKey: 'lastToolCalibrationSyncTime',
        supportsIncrementalSync: true,
        async syncHandler(db, storeName, data, isFirstSync) {
            await incrementalSyncWithDeletion(db, storeName, data, isFirstSync, 'ToolCalibration');
        },
    },
    toolDocs: {
        storeName: TOOL_DOCS_STORE,
        endpoint: '/tool-docs',
        localStorageKey: 'lastToolDocsSyncTime',
        supportsIncrementalSync: true,
        async syncHandler(db, storeName, data, isFirstSync) {
            await incrementalSyncWithDeletion(db, storeName, data, isFirstSync, 'ToolDocs');
        },
    },
    toolAssignments: {
        storeName: TOOL_ASSIGNMENT_STORE,
        endpoint: '/tool-assignments',
        localStorageKey: 'lastToolAssignmentsSyncTime',
        supportsIncrementalSync: true,
        async syncHandler(db, storeName, data, isFirstSync) {
            await incrementalSyncWithDeletion(db, storeName, data, isFirstSync, 'ToolAssignments');
        },
    },
    trainingCourses: {
        storeName: TRAINING_COURSE_STORE,
        endpoint: '/training/courses',
        localStorageKey: 'lastTrainingCoursesSyncTime',
        async syncHandler(db, storeName) {
            const resp = await axiosInstance.get('/training/courses');
            const list = Array.isArray(resp?.data?.courses) ? resp.data.courses : [];
            const tx = db.transaction(storeName, 'readwrite');
            const store = tx.objectStore(storeName);
            await store.clear();
            for (const c of list) {
                await store.put(c);
            }
            await tx.done;
            localStorage.setItem('lastTrainingCoursesSyncTime', new Date().toISOString());
            console.log(`[TrainingCourses] Synced ${list.length} courses`);
        },
    },
    trainingQuizzes: {
        storeName: TRAINING_QUIZ_STORE,
        endpoint: '/training/quizzes',
        localStorageKey: 'lastTrainingQuizzesSyncTime',
        async syncHandler(db, storeName) {
            const resp = await axiosInstance.get('/training/quizzes');
            const list = Array.isArray(resp?.data?.quizzes) ? resp.data.quizzes : [];
            const tx = db.transaction(storeName, 'readwrite');
            const store = tx.objectStore(storeName);
            await store.clear();
            for (const q of list) {
                await store.put(q);
            }
            await tx.done;
            localStorage.setItem('lastTrainingQuizzesSyncTime', new Date().toISOString());
            console.log(`[TrainingQuizzes] Synced ${list.length} quizzes`);
        },
    },
    // trainingSessions НЕ синхронизируется с сервера — это локальный offline-queue
    // мутаций на конкретном устройстве. Создание/send/reset/extend пишут актуальное
    // состояние сессии в IDB. История и закрытые сессии — только в Symfony админке.
    sds: {
        storeName: SDS_STORE,
        endpoint: '/sds',
        localStorageKey: 'lastSdsSyncTime',
        async syncHandler(db, storeName, data) {
            const tx = db.transaction(storeName, 'readwrite');
            const store = tx.objectStore(storeName);
            await store.clear();
            const list = Array.isArray(data) ? data : [];
            for (const item of list) {
                await store.put(item);
            }
            await tx.done;
            console.log(`[SDS] Synced ${list.length} records`);
        },
    },
    // Назначение инцидента проставляют вручную во внешней базе (SafetyIncident.AssignedTo),
    // а закрывают через dateClosed. Сюда это доезжает только синком: компоненты
    // читают IndexedDB, в сеть за списком не ходят.
    incidentAssignments: {
        storeName: INCIDENT_STORE,
        endpoint: '/incident-assignments',
        localStorageKey: 'lastIncidentAssignmentsSyncTime',
        async syncHandler(db, storeName, data) {
            await mergeIncidentAssignments(db, storeName, data);
        },
    },
};

/**
 * Мердж инцидентов из синка назначений.
 *
 * Стор инцидентов — единственный, который синк НЕ имеет права чистить: в нём
 * лежат локальные черновики и уже отправленные записи этого устройства. Поэтому
 * тут не clear+put, а точечное слияние по uuid:
 *
 *  - closedUuids — инцидент закрыт во внешней базе, удаляем локально (у всех:
 *    и у того, кто отправил, и у назначенного);
 *  - assigned    — «мне поручили дозаполнить». Записи может не быть вовсе
 *    (отправлял другой человек с другого айпада) — тогда создаём;
 *  - statuses    — «что стало с моим отправленным»: только метаданные.
 *
 * payload существующей записи не перезаписываем никогда: на устройстве может
 * лежать несохранённая правка, а сервер отдаёт снимок на момент запроса.
 */
async function mergeIncidentAssignments(db, storeName, data) {
    const assigned = Array.isArray(data?.assigned) ? data.assigned : [];
    const statuses = Array.isArray(data?.statuses) ? data.statuses : [];
    const closedUuids = Array.isArray(data?.closedUuids) ? data.closedUuids : [];

    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const uuidIndex = store.index('uuid');

    // Метаданные workflow, общие для assigned и statuses
    const meta = (item) => ({
        siNumber: item.siNumber ?? null,
        workflowStage: item.workflowStage ?? null,
        assignedToName: item.assignedToName ?? null,
        assignedToEmployeeId: item.assignedToEmployeeId ?? null,
        assignedAt: item.assignedAt ?? null,
        fullReportSubmittedAt: item.fullReportSubmittedAt ?? null,
        completedByName: item.completedByName ?? null,
        closedAt: item.closedAt ?? null,
        reportedByName: item.reportedByName ?? null,
        reportedByEmployeeId: item.reportedByEmployeeId ?? null,
    });

    let created = 0;
    let updated = 0;
    let removed = 0;

    for (const item of assigned) {
        if (!item?.uuid) continue;
        const existing = await uuidIndex.get(item.uuid);

        if (existing) {
            await store.put({
                ...existing,
                ...meta(item),
                backendId: existing.backendId ?? item.backendId,
                // payload оставляем локальный — он может быть свежее серверного
                payload: existing.payload ?? item.payload,
                serverCompleted: item.completed ?? null,
                updatedAt: existing.updatedAt || item.updatedAt,
            });
            updated++;
        } else {
            await store.add({
                uuid: item.uuid,
                status: item.status || 'step1_submitted',
                payload: item.payload || {},
                backendId: item.backendId ?? null,
                serverCompleted: item.completed ?? null,
                // Запись пришла с сервера, а не создана здесь: удалять её нельзя
                origin: 'assignment',
                createdAt: item.createdAt || new Date().toISOString(),
                updatedAt: item.updatedAt || new Date().toISOString(),
                submittedAt: item.submittedAt || null,
                ...meta(item),
            });
            created++;
        }
    }

    for (const item of statuses) {
        if (!item?.uuid) continue;
        const existing = await uuidIndex.get(item.uuid);
        // Записи нет — значит отправляли с другого устройства. Репортёру
        // дозаполнять нечего, поэтому ради строки статуса ничего не создаём.
        if (!existing) continue;

        await store.put({ ...existing, ...meta(item) });
        updated++;
    }

    for (const uuid of closedUuids) {
        const existing = await uuidIndex.get(uuid);
        if (existing) {
            await store.delete(existing.id);
            removed++;
        }
    }

    await tx.done;
    console.log(`[IncidentAssignments] created=${created}, updated=${updated}, removed=${removed}`);
}

/**
 * Paginated sync handler for large tables (Equipment, EquipLocation, PurchaseOrder).
 * Fetches data page by page from the API and dispatches progress events.
 */
async function paginatedSyncHandler(db, storeName, endpoint, label, isFirstSync) {
    const lastSyncTime = localStorage.getItem(
        storeName === EQUIPMENT_STORE ? 'lastEquipmentSyncTime' :
        storeName === EQUIP_LOCATION_STORE ? 'lastEquipLocationSyncTime' :
        'lastPurchaseOrderSyncTime'
    );

    // Build base URL
    let baseUrl = endpoint;
    const useIncremental = !isFirstSync && lastSyncTime;
    if (useIncremental) {
        baseUrl += `?since=${encodeURIComponent(lastSyncTime)}`;
    }

    // First request to get total
    const separator = baseUrl.includes('?') ? '&' : '?';
    const firstResponse = await axiosInstance.get(`${baseUrl}${separator}page=1&limit=2000`);
    const firstData = firstResponse.data;
    const meta = firstData.meta;
    const totalRecords = meta.total;
    const totalPages = Math.ceil(totalRecords / meta.limit);

    // Dispatch start event
    window.dispatchEvent(new CustomEvent('equipmentSyncProgress', {
        detail: { label, phase: 'start', total: totalRecords, loaded: 0 }
    }));

    console.log(`[${label}] Sync started: ${totalRecords} records, ${totalPages} pages (${useIncremental ? 'incremental' : 'full'})`);

    if (isFirstSync && !useIncremental) {
        // Full sync: clear store first
        const clearTx = db.transaction(storeName, 'readwrite');
        await clearTx.objectStore(storeName).clear();
        await clearTx.done;
    }

    let loaded = 0;
    let serverTime = meta.syncTimestamp;

    // Process first page
    const records = firstData.data;
    if (records.length > 0) {
        await putBatch(db, storeName, records, useIncremental);
        loaded += records.length;
    }

    window.dispatchEvent(new CustomEvent('equipmentSyncProgress', {
        detail: { label, phase: 'progress', total: totalRecords, loaded }
    }));

    // Fetch remaining pages
    if (meta.hasMore) {
        for (let page = 2; page <= totalPages; page++) {
            const resp = await axiosInstance.get(`${baseUrl}${separator}page=${page}&limit=2000`);
            const pageData = resp.data;
            if (pageData.data && pageData.data.length > 0) {
                await putBatch(db, storeName, pageData.data, useIncremental);
                loaded += pageData.data.length;
            }

            window.dispatchEvent(new CustomEvent('equipmentSyncProgress', {
                detail: { label, phase: 'progress', total: totalRecords, loaded }
            }));

            console.log(`[${label}] Page ${page}/${totalPages} — ${loaded}/${totalRecords}`);
        }
    }

    // Update sync timestamp
    if (serverTime) {
        const key = storeName === EQUIPMENT_STORE ? 'lastEquipmentSyncTime' :
                    storeName === EQUIP_LOCATION_STORE ? 'lastEquipLocationSyncTime' :
                    'lastPurchaseOrderSyncTime';
        localStorage.setItem(key, serverTime);
    }

    window.dispatchEvent(new CustomEvent('equipmentSyncProgress', {
        detail: { label, phase: 'done', total: totalRecords, loaded }
    }));

    console.log(`[${label}] Sync completed: ${loaded} records`);
}

/**
 * Batch put records into IndexedDB. For incremental sync, handles status=false as deletes.
 */
async function putBatch(db, storeName, records, isIncremental) {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    for (const record of records) {
        if (isIncremental && record.status === false) {
            try { await store.delete(record.id); } catch (e) { /* ignore */ }
        } else {
            await store.put(record);
        }
    }
    await tx.done;
}

/**
 * Incremental sync with deletion support.
 * Used for Tool Inventory, Calibration, Docs, Assignments.
 * Same pattern as ToolBoxTalks sync handler.
 */
async function incrementalSyncWithDeletion(db, storeName, data, isFirstSync, label) {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);

    if (isFirstSync) {
        await store.clear();
        console.log(`[${label}] First sync - cleared store`);
    }

    let addedCount = 0;
    let updatedCount = 0;
    let deletedCount = 0;

    for (const record of data) {
        if (record.status === false) {
            const existing = await store.get(record.id);
            if (existing) {
                await store.delete(record.id);
                deletedCount++;
            }
        } else {
            const existing = await store.get(record.id);
            if (existing) {
                updatedCount++;
            } else {
                addedCount++;
            }
            await store.put(record);
        }
    }

    await tx.done;
    console.log(`[${label}] Sync completed (${isFirstSync ? 'full' : 'incremental'}): added=${addedCount}, updated=${updatedCount}, deleted=${deletedCount}`);
}
